import {
  SET_SAVED_SEARCHES,
  START_LOAD_SEARCHES,
  START_DELETE_SEARCH,
  END_DELETE_SEARCH
} from '../actions/saved_searches';

export default function (state = {}, action) {
  switch (action.type) {
  case SET_SAVED_SEARCHES:
    return { ...state, searches: action.searches, loading: false };
  case START_LOAD_SEARCHES:
    return { ...state, loading: true };
  case START_DELETE_SEARCH:
    return { ...state, deleteSavedSearch: action.search };
  case END_DELETE_SEARCH:
    return { ...state, deleteSavedSearch: null };
  default:
    return state;
  }
}
